import { controls,grouped } from "../controls";
const customer_documents = {
label: "Customer Documents",
pageLabel: "Customer Documents",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Document Type Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "document_type_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Document Purpose Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "document_purpose_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Document Ref"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "document_ref",maxlength:36}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Doc Start Date",target: "doc_start_date"}),
...controls.magicDate({ tab: "filter", name: "doc_start_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Doc End Date",target: "doc_end_date"}),
...controls.magicDate({ tab: "filter", name: "doc_end_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Document"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "document_uri",width:"col-sm-4",maxlength:236}),
]
,form:[
...controls.displayText({ tab: "general", label: "Document Type",star:false}),
...controls.oc({ tab: "general", c: "DocumentType", placeHolder: "Document Type Code", name: "document_type_code",fastpath: "document_types",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "document_type_display"}),
...controls.displayText({ tab: "general", label: "Document Purpose",star:false}),
...controls.autoComplete({tab: "general", name: "document_purpose_code", width: "col-sm-2",controlType: "DocumentPurpose"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Document Ref",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "document_ref",maxlength:36}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Doc Start Date",target: "doc_start_date",star:false}),
...controls.magicDate({ tab: "general", name: "doc_start_date", dateType: "ontype",maxDate:'n' }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Doc End Date",target: "doc_end_date",star:false}),
...controls.magicDate({ tab: "general", name: "doc_end_date", dateType: "ontype",minDate:'1 months from now' }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Document",star:false}),
...controls.FileUpload({ tab: "general",width: "col-sm-4", name: "document_uri",options:{ max: 120000, type: "image" } }),
]
,history:{
perPage: 10,
reportHeader: "Customer Documents",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Document Type Id",accessor: "document_type_id",},
{Header: "Document Purpose Id",accessor: "document_purpose_id",},
{Header: "Document Ref",accessor: "document_ref",},
{Header: "Doc Start Date",accessor: "doc_start_date",type:'date'},
{Header: "Doc End Date",accessor: "doc_end_date",type:'date'},
{Header: "Document",accessor: "document_uri",},
]}};
export default customer_documents;